import React from 'react';
import EmailIcon from './email.svg';
import styles from './LeadEmail.module.scss';

function LeadEmail(props) {
    const { className = '', lead } = props,
        { email } = lead?.participant ?? {};

    if (!lead) return null;
    if (!email) return null;

    return (
        <div className={[className, styles.LeadEmail].join(' ')}>
            <EmailIcon />
            <a href={'mailto:' + email}>{email}</a>
        </div>
    );
}

export default LeadEmail;
